import { generarAsientoNomina } from "../core/accounting.js";
import { getParametrosNomina, saveData, saveParametrosNomina, siguienteNumeroDoc } from "../core/cloudSync.js";
import { C, CARGO_LABELS, DEFAULT_PARAMETROS_NOMINA, NIVELES_RIESGO_ARL, NIVEL_RIESGO_ARL_LABELS, PERIODICIDAD_NOMINA, PERIODICIDAD_NOMINA_LABELS } from "../core/config.js";
import { liquidarEmpleado } from "../core/payroll.js";
import { state } from "../core/state.js";
import { btnStyle, escapeHTML, fmtCOP, fmtDate, genId, inputStyle, parseNumber, today } from "../core/utils.js";
import { render } from "../ui/app.js";
import { liquidarComisiones } from "./comisiones.js";

function primerDiaMesActual() {
  const hoy = new Date(today() + "T12:00:00");
  return `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, "0")}-01`;
}

function ultimoDiaMesActual() {
  const hoy = new Date(today() + "T12:00:00");
  const ultimo = new Date(hoy.getFullYear(), hoy.getMonth() + 1, 0);
  return `${ultimo.getFullYear()}-${String(ultimo.getMonth() + 1).padStart(2, "0")}-${String(ultimo.getDate()).padStart(2, "0")}`;
}

function calcularComisionesPeriodo(empleado, desde, hasta) {
  if (empleado.cargo !== "vendedor") return 0;
  try {
    return liquidarComisiones(desde, hasta, empleado.id).reduce((s, r) => s + (r.comisionMonto || 0), 0);
  } catch { return 0; }
}

export function renderNomina() {
  if (!state.nominaTab) state.nominaTab = "liquidacion";
  const tab = state.nominaTab;

  const header = `
    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px;padding-bottom:10px;border-bottom:3px solid ${C.gold};">
      <div style="display:flex;gap:10px;align-items:center;">
        <img src="${window.LOGO}" alt="Aura" style="height:42px;object-fit:contain;"/>
        <div>
          <h2 style="margin:0;font-size:16px;color:${C.text};font-weight:700;">🧑‍🌾 Nómina</h2>
          <p style="margin:3px 0 0;color:${C.muted};font-size:11.5px;">Liquidación de nómina, aportes de seguridad social y provisión de prestaciones sociales</p>
        </div>
      </div>
    </div>
  `;

  const tabs = [
    { id: "liquidacion", label: "🧮 Liquidación" },
    { id: "historico", label: "📜 Histórico" },
    { id: "configuracion", label: "⚙️ Configuración" }
  ].map(t => `
    <button data-action="nomina-tab" data-tab="${t.id}" style="
      padding:10px 18px;background:${tab === t.id ? "white" : "transparent"};
      border:none;border-bottom:3px solid ${tab === t.id ? C.accent : "transparent"};
      color:${tab === t.id ? "#4C5FA8" : C.muted};font-weight:700;font-size:12px;cursor:pointer;margin-bottom:-1px;font-family:inherit;
    ">${t.label}</button>
  `).join("");

  let body;
  if (tab === "historico") body = renderNominaHistoricoTab();
  else if (tab === "configuracion") body = renderNominaConfiguracionTab();
  else body = renderNominaLiquidacionTab();

  return `
    ${header}
    <div style="display:flex;border-bottom:1px solid ${C.border};margin-bottom:10px;overflow-x:auto;">${tabs}</div>
    ${body}
  `;
}

function renderNominaLiquidacionTab() {
  const liq = state.nominaLiquidacionActual;
  if (!liq) return renderFormNuevaLiquidacion();
  return renderDetalleLiquidacion(liq);
}

function renderFormNuevaLiquidacion() {
  const parametrosNomina = getParametrosNomina();
  const empleadosSinSalario = (state.data.empleados || []).filter(e => !(parseNumber(e.salario_base) > 0));
  return `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:11px;">
      <h3 style="margin:0 0 4px;font-size:12px;color:${C.text};">Nueva liquidación de nómina</h3>
      <p style="margin:0 0 9px;font-size:11.5px;color:${C.muted};">Se liquidarán todos los empleados con salario base configurado. Ajusta las fechas si vas a liquidar una quincena en vez del mes completo.</p>
      <div style="display:flex;gap:10px;flex-wrap:wrap;align-items:flex-end;">
        <div>
          <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">Periodicidad</label>
          <select id="nomina-tipo-periodo" style="${inputStyle}">
            ${PERIODICIDAD_NOMINA.map(p => `<option value="${p}" ${p === parametrosNomina.periodicidad_default ? "selected" : ""}>${PERIODICIDAD_NOMINA_LABELS[p]}</option>`).join("")}
          </select>
        </div>
        <div>
          <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">Periodo desde</label>
          <input id="nomina-periodo-desde" type="date" value="${primerDiaMesActual()}" style="${inputStyle}"/>
        </div>
        <div>
          <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">Periodo hasta</label>
          <input id="nomina-periodo-hasta" type="date" value="${ultimoDiaMesActual()}" style="${inputStyle}"/>
        </div>
        <div>
          <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">Fecha de pago</label>
          <input id="nomina-fecha-pago" type="date" value="${today()}" style="${inputStyle}"/>
        </div>
        <button data-action="nomina-calcular" style="${btnStyle("#4C5FA8")}">🧮 Calcular liquidación</button>
      </div>
      ${empleadosSinSalario.length > 0 ? `
        <div style="margin-top:16px;background:#fffbeb;border:1px solid #fde68a;border-radius:6px;padding:7px 10px;font-size:10.5px;color:#92400e;">
          ⚠️ ${empleadosSinSalario.length} empleado${empleadosSinSalario.length !== 1 ? "s" : ""} sin salario base configurado (no se incluirá${empleadosSinSalario.length !== 1 ? "n" : ""} en la liquidación): ${empleadosSinSalario.map(e => escapeHTML(e.nombre)).join(", ")}.
        </div>
      ` : ""}
    </div>
  `;
}

function renderDetalleLiquidacion(liq) {
  const detalle = liq.detalle_empleados || [];
  const totalDevengado = detalle.reduce((s, d) => s + d.devengado.totalDevengado, 0);
  const totalDeducciones = detalle.reduce((s, d) => s + d.deducciones.totalDeducciones, 0);
  const totalNeto = detalle.reduce((s, d) => s + d.netoPagar, 0);
  const totalAportesPatronales = detalle.reduce((s, d) => s + d.aportesPatronales.totalAportesPatronales, 0);
  const totalPrestaciones = detalle.reduce((s, d) => s + d.provisionPrestaciones.totalProvisionPrestaciones, 0);

  const ajusteInput = (empleadoId, campo, valor) => `
    <input type="number" inputmode="decimal" min="0" step="1"
      data-nomina-ajuste="${empleadoId}" data-nomina-campo="${campo}"
      value="${valor > 0 ? valor : ""}" placeholder="0"
      style="width:100px;padding:5px 7px;border:1px solid ${C.border};border-radius:6px;font-size:11.5px;text-align:right;font-family:inherit;"/>
  `;

  const rows = detalle.map(d => {
    const ajustes = d._ajustes || { horasExtra: 0, otrosDevengados: 0, otrasDeducciones: 0 };
    return `
    <tr style="border-top:1px solid ${C.border};">
      <td style="padding:6px 10px;font-weight:700;">${escapeHTML(d.empleadoNombre)}</td>
      <td style="padding:6px 10px;font-size:10.5px;color:${C.muted};">${CARGO_LABELS[d.empleadoCargo] || "—"}</td>
      <td style="padding:6px 10px;text-align:right;">${ajusteInput(d.empleadoId, "horasExtra", ajustes.horasExtra)}</td>
      <td style="padding:6px 10px;text-align:right;">${ajusteInput(d.empleadoId, "otrosDevengados", ajustes.otrosDevengados)}</td>
      <td style="padding:6px 10px;text-align:right;">${ajusteInput(d.empleadoId, "otrasDeducciones", ajustes.otrasDeducciones)}</td>
      <td style="padding:6px 10px;text-align:right;">${fmtCOP(d.devengado.totalDevengado)}</td>
      <td style="padding:6px 10px;text-align:right;">${fmtCOP(d.deducciones.totalDeducciones)}</td>
      <td style="padding:6px 10px;text-align:right;font-weight:700;color:#4C5FA8;">${fmtCOP(d.netoPagar)}</td>
      <td style="padding:6px 10px;text-align:right;font-size:10.5px;color:${C.muted};">${fmtCOP(d.aportesPatronales.totalAportesPatronales)}</td>
      <td style="padding:6px 10px;text-align:right;font-size:10.5px;color:${C.muted};">${fmtCOP(d.provisionPrestaciones.totalProvisionPrestaciones)}</td>
    </tr>
  `;
  }).join("");

  return `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:11px;margin-bottom:10px;">
      <div style="display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:10px;margin-bottom:4px;">
        <div>
          <h3 style="margin:0;font-size:12px;color:${C.text};">Liquidación calculada — ${PERIODICIDAD_NOMINA_LABELS[liq.tipo_periodo] || liq.tipo_periodo}</h3>
          <p style="margin:3px 0 0;font-size:11.5px;color:${C.muted};">${fmtDate(liq.periodo_desde)} → ${fmtDate(liq.periodo_hasta)} · Fecha de pago: ${fmtDate(liq.fecha_pago)} · ${detalle.length} empleado${detalle.length !== 1 ? "s" : ""}</p>
        </div>
        <div style="display:flex;gap:10px;">
          <button data-action="nomina-descartar" style="${btnStyle(null, "secondary")}">✕ Descartar</button>
          <button data-action="nomina-abrir-confirmar" style="${btnStyle("#4C5FA8")}">✅ Confirmar liquidación</button>
        </div>
      </div>
    </div>

    <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(160px,1fr));gap:9px;margin-bottom:10px;">
      <div style="background:white;border:2px solid #4C5FA830;border-radius:6px;padding:11px;">
        <div style="font-size:10.5px;color:${C.muted};font-weight:600;margin-bottom:4px;">TOTAL DEVENGADO</div>
        <div style="font-size:17px;font-weight:800;color:#4C5FA8;">${fmtCOP(totalDevengado)}</div>
      </div>
      <div style="background:white;border:2px solid ${C.border};border-radius:6px;padding:11px;">
        <div style="font-size:10.5px;color:${C.muted};font-weight:600;margin-bottom:4px;">DEDUCCIONES EMPLEADO</div>
        <div style="font-size:17px;font-weight:800;color:${C.text};">${fmtCOP(totalDeducciones)}</div>
      </div>
      <div style="background:white;border:2px solid ${C.border};border-radius:6px;padding:11px;">
        <div style="font-size:10.5px;color:${C.muted};font-weight:600;margin-bottom:4px;">NETO A PAGAR</div>
        <div style="font-size:17px;font-weight:800;color:${C.text};">${fmtCOP(totalNeto)}</div>
      </div>
      <div style="background:white;border:2px solid ${C.border};border-radius:6px;padding:11px;">
        <div style="font-size:10.5px;color:${C.muted};font-weight:600;margin-bottom:4px;">APORTES PATRONALES</div>
        <div style="font-size:17px;font-weight:800;color:${C.text};">${fmtCOP(totalAportesPatronales)}</div>
      </div>
      <div style="background:white;border:2px solid ${C.border};border-radius:6px;padding:11px;">
        <div style="font-size:10.5px;color:${C.muted};font-weight:600;margin-bottom:4px;">PROVISIÓN PRESTACIONES</div>
        <div style="font-size:17px;font-weight:800;color:${C.text};">${fmtCOP(totalPrestaciones)}</div>
      </div>
    </div>

    <div style="background:white;border:1px solid ${C.border};border-radius:6px;overflow:auto;">
      <table style="width:100%;border-collapse:collapse;font-size:12px;">
        <thead>
          <tr style="background:#f1f5f9;">
            <th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">EMPLEADO</th>
            <th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">CARGO</th>
            <th style="padding:6px 10px;text-align:right;font-size:10.5px;font-weight:700;color:${C.text};">HORAS EXTRA ($)</th>
            <th style="padding:6px 10px;text-align:right;font-size:10.5px;font-weight:700;color:${C.text};">OTROS DEVENGADOS ($)</th>
            <th style="padding:6px 10px;text-align:right;font-size:10.5px;font-weight:700;color:${C.text};">OTRAS DEDUCCIONES ($)</th>
            <th style="padding:6px 10px;text-align:right;font-size:10.5px;font-weight:700;color:${C.text};">DEVENGADO</th>
            <th style="padding:6px 10px;text-align:right;font-size:10.5px;font-weight:700;color:${C.text};">DEDUCCIONES</th>
            <th style="padding:6px 10px;text-align:right;font-size:10.5px;font-weight:700;color:${C.text};">NETO A PAGAR</th>
            <th style="padding:6px 10px;text-align:right;font-size:10.5px;font-weight:700;color:${C.text};">APORTES PATR.</th>
            <th style="padding:6px 10px;text-align:right;font-size:10.5px;font-weight:700;color:${C.text};">PRESTACIONES</th>
          </tr>
        </thead>
        <tbody>${rows}</tbody>
      </table>
    </div>
    <div style="margin-top:10px;background:#fffbeb;border:1px solid #fde68a;border-radius:6px;padding:7px 10px;font-size:10.5px;color:#92400e;">
      💡 Esta liquidación aún no se ha guardado. Escribe un valor en "Horas extra", "Otros devengados" u "Otras deducciones" y sal del campo (Tab o clic afuera) para que se recalculen el devengado, las deducciones y el neto de esa fila. Al confirmar se genera un asiento contable consolidado en el Libro Diario y se registra en el histórico.
    </div>
  `;
}

function renderNominaHistoricoTab() {
  const liquidaciones = [...(state.data.nomina_liquidaciones || [])].sort((a, b) => (b.fecha_pago || "").localeCompare(a.fecha_pago || ""));
  if (liquidaciones.length === 0) {
    return `
      <div style="padding:26px;text-align:center;background:white;border:2px dashed ${C.border};border-radius:6px;">
        <div style="font-size:40px;margin-bottom:10px;">📜</div>
        <div style="color:${C.muted};font-size:14px;">Sin liquidaciones de nómina registradas aún.</div>
      </div>
    `;
  }
  const rows = liquidaciones.map(l => {
    const totalNeto = (l.detalle_empleados || []).reduce((s, d) => s + (d.netoPagar || 0), 0);
    const tieneElectronica = (l.nomina_electronica || []).length > 0;
    return `
      <tr style="border-top:1px solid ${C.border};">
        <td style="padding:6px 10px;font-weight:700;">${escapeHTML(l.numero || "—")}</td>
        <td style="padding:6px 10px;">${PERIODICIDAD_NOMINA_LABELS[l.tipo_periodo] || escapeHTML(l.tipo_periodo || "—")}</td>
        <td style="padding:6px 10px;">${fmtDate(l.periodo_desde)} → ${fmtDate(l.periodo_hasta)}</td>
        <td style="padding:6px 10px;">${fmtDate(l.fecha_pago)}</td>
        <td style="padding:6px 10px;text-align:center;">${(l.detalle_empleados || []).length}</td>
        <td style="padding:6px 10px;text-align:right;font-weight:700;">${fmtCOP(totalNeto)}</td>
        <td style="padding:6px 10px;">${l.estado === "confirmada" ? `<span style="color:#059669;font-weight:700;">✅ Confirmada</span>` : escapeHTML(l.estado || "—")}</td>
        <td style="padding:6px 10px;text-align:right;">
          ${tieneElectronica
            ? `<button data-action="nomina-ver-electronica" data-id="${l.id}" style="${btnStyle(null,"ghost",true)}" title="Ver documentos de nómina electrónica (simulados)">📤 Nómina electrónica</button>`
            : `<span style="font-size:10.5px;color:${C.muted};">— sin generar</span>`}
        </td>
      </tr>
    `;
  }).join("");
  return `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;overflow:auto;">
      <table style="width:100%;border-collapse:collapse;font-size:12px;">
        <thead>
          <tr style="background:#f1f5f9;">
            <th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">N° LIQUIDACIÓN</th>
            <th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">PERIODICIDAD</th>
            <th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">PERIODO</th>
            <th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">FECHA DE PAGO</th>
            <th style="padding:6px 10px;text-align:center;font-size:10.5px;font-weight:700;color:${C.text};">EMPLEADOS</th>
            <th style="padding:6px 10px;text-align:right;font-size:10.5px;font-weight:700;color:${C.text};">NETO TOTAL</th>
            <th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">ESTADO</th>
            <th></th>
          </tr>
        </thead>
        <tbody>${rows}</tbody>
      </table>
    </div>
  `;
}

function renderNominaConfiguracionTab() {
  const pn = getParametrosNomina();

  const campo = (key, label, opts = {}) => {
    const isPct = !!opts.pct;
    const value = pn[key] != null ? String(pn[key]) : "";
    return `
      <div>
        <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">${label}</label>
        <div style="position:relative;">
          <input id="pn-${key}" type="number" inputmode="decimal" step="${opts.step || "0.01"}" min="0"
            value="${escapeHTML(value)}"
            style="${inputStyle}${isPct ? "padding-right:26px;" : ""}text-align:right;"/>
          ${isPct ? `<span style="position:absolute;right:10px;top:50%;transform:translateY(-50%);font-size:11.5px;color:${C.muted};">%</span>` : ""}
        </div>
        ${opts.help ? `<div style="font-size:10px;color:${C.muted};margin-top:3px;">${opts.help}</div>` : ""}
      </div>`;
  };

  const toggle = (key, label, help) => `
    <label style="display:flex;align-items:flex-start;gap:8px;font-size:11.5px;color:${C.text};cursor:pointer;background:#f8fafc;border:1px solid ${C.border};border-radius:6px;padding:6px 10px;">
      <input id="pn-${key}" type="checkbox" ${pn[key] ? "checked" : ""} style="margin-top:2px;"/>
      <span>
        <strong>${label}</strong>
        ${help ? `<div style="font-size:10px;color:${C.muted};margin-top:2px;">${help}</div>` : ""}
      </span>
    </label>`;

  const aviso = `
    <div style="background:#fffbeb;border:1px solid #fde68a;border-radius:6px;padding:12px 16px;margin-bottom:10px;font-size:11.5px;color:#92400e;">
      ⚠️ <strong>Importante:</strong> el SMLMV y el auxilio de transporte cambian cada diciembre/enero por decreto del Gobierno Nacional. Actualízalos aquí apenas se publique el decreto — no requiere ningún cambio de código.
    </div>
  `;

  const seccionBase = `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:11px;margin-bottom:18px;">
      <h3 style="margin:0 0 9px;font-size:14px;font-weight:700;color:${C.text};">💲 Valores base</h3>
      <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:10px;">
        ${campo("anio_vigencia", "Año de vigencia", { step: "1" })}
        ${campo("smlmv", "SMLMV vigente (COP)", { step: "1" })}
        ${campo("auxilio_transporte", "Auxilio de transporte (COP)", { step: "1" })}
        ${campo("auxilio_transporte_tope_smlmv", "Tope auxilio (en SMLMV)", { step: "0.1", help: "Aplica si el salario es menor o igual a este múltiplo del SMLMV." })}
        ${(() => {
          const opts = [{ value: "mensual", label: "Mensual" }, { value: "quincenal", label: "Quincenal" }];
          return `
        <div>
          <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">Periodicidad por defecto</label>
          <select id="pn-periodicidad_default" style="${inputStyle}">
            ${opts.map(o => `<option value="${o.value}" ${pn.periodicidad_default === o.value ? "selected" : ""}>${o.label}</option>`).join("")}
          </select>
        </div>`;
        })()}
      </div>
    </div>
  `;

  const seccionSeguridadSocial = `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:11px;margin-bottom:18px;">
      <h3 style="margin:0 0 9px;font-size:14px;font-weight:700;color:${C.text};">🩺 Salud y pensión</h3>
      <div style="display:grid;grid-template-columns:1fr 1fr 1fr 1fr;gap:10px;">
        ${campo("salud_empleado_pct", "% Salud empleado", { pct: true })}
        ${campo("pension_empleado_pct", "% Pensión empleado", { pct: true })}
        ${campo("salud_patronal_pct", "% Salud patronal", { pct: true })}
        ${campo("pension_patronal_pct", "% Pensión patronal", { pct: true })}
      </div>
    </div>
  `;

  const seccionArl = `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:11px;margin-bottom:18px;">
      <h3 style="margin:0 0 9px;font-size:14px;font-weight:700;color:${C.text};">⛑️ Tabla ARL por nivel de riesgo</h3>
      <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(100px,1fr));gap:10px;">
        ${NIVELES_RIESGO_ARL.map(n => `
          <div>
            <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">${NIVEL_RIESGO_ARL_LABELS[n]}</label>
            <div style="position:relative;">
              <input id="pn-tabla_arl-${n}" type="number" inputmode="decimal" step="0.001" min="0" value="${escapeHTML(String((pn.tabla_arl || {})[n] ?? ""))}" style="${inputStyle}padding-right:26px;text-align:right;"/>
              <span style="position:absolute;right:10px;top:50%;transform:translateY(-50%);font-size:11.5px;color:${C.muted};">%</span>
            </div>
          </div>
        `).join("")}
      </div>
    </div>
  `;

  const seccionParafiscales = `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:11px;margin-bottom:18px;">
      <h3 style="margin:0 0 9px;font-size:14px;font-weight:700;color:${C.text};">🏛️ Parafiscales</h3>
      <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:10px;margin-bottom:9px;">
        ${campo("sena_pct", "% SENA", { pct: true })}
        ${campo("icbf_pct", "% ICBF", { pct: true })}
        ${campo("caja_compensacion_pct", "% Caja de Compensación", { pct: true })}
      </div>
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:9px;">
        ${toggle("exonera_sena_icbf", "Exonerar SENA e ICBF", "Ley 1607 de 2012 — aplica a empresas que cumplan los requisitos de exoneración de parafiscales.")}
        ${toggle("exonera_salud_patronal", "Exonerar salud patronal", "Ley 1607 de 2012 — aplica a empresas que cumplan los requisitos de exoneración. La Caja de Compensación nunca se exonera.")}
      </div>
    </div>
  `;

  const seccionPrestaciones = `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:11px;margin-bottom:18px;">
      <h3 style="margin:0 0 9px;font-size:14px;font-weight:700;color:${C.text};">🎁 Prestaciones sociales</h3>
      <div style="display:grid;grid-template-columns:1fr 1fr 1fr 1fr;gap:10px;">
        ${campo("cesantias_pct", "% Cesantías", { pct: true })}
        ${campo("intereses_cesantias_pct", "% Intereses cesantías (mensual)", { pct: true })}
        ${campo("prima_pct", "% Prima de servicios", { pct: true })}
        ${campo("vacaciones_pct", "% Vacaciones", { pct: true })}
      </div>
    </div>
  `;

  const tramos = pn.fondo_solidaridad_tramos || [];
  const seccionFondoSolidaridad = `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:11px;margin-bottom:18px;">
      <h3 style="margin:0 0 4px;font-size:14px;font-weight:700;color:${C.text};">⚖️ Fondo de Solidaridad Pensional (tramos)</h3>
      <p style="margin:0 0 12px;font-size:10.5px;color:${C.muted};">Aplica sobre el total del IBC cuando el salario mensual equivalente supera 4 SMLMV. Estos tramos son de referencia legal y no son editables desde aquí.</p>
      <table style="width:100%;border-collapse:collapse;font-size:11.5px;">
        <thead><tr style="background:#f8fafc;">
          <th style="text-align:left;padding:6px 8px;font-size:10.5px;color:${C.muted};">Desde (SMLMV)</th>
          <th style="text-align:left;padding:6px 8px;font-size:10.5px;color:${C.muted};">Hasta (SMLMV)</th>
          <th style="text-align:right;padding:6px 8px;font-size:10.5px;color:${C.muted};">%</th>
        </tr></thead>
        <tbody>
          ${tramos.map(t => `<tr style="border-top:1px solid ${C.border};">
            <td style="padding:6px 8px;">${t.desde_smlmv}</td>
            <td style="padding:6px 8px;">${t.hasta_smlmv ?? "en adelante"}</td>
            <td style="padding:6px 8px;text-align:right;">${t.pct}%</td>
          </tr>`).join("")}
        </tbody>
      </table>
    </div>
  `;

  const acciones = `
    <div style="display:flex;gap:10px;">
      <button data-action="nomina-guardar-parametros" style="${btnStyle("#4C5FA8")}">💾 Guardar parámetros</button>
      <button data-action="nomina-restaurar-parametros" style="${btnStyle(null, "secondary")}">↺ Restaurar valores por defecto</button>
    </div>
  `;

  return aviso + seccionBase + seccionSeguridadSocial + seccionArl + seccionParafiscales + seccionPrestaciones + seccionFondoSolidaridad + acciones;
}

function showConfirmarNominaModal() {
  const liq = state.nominaLiquidacionActual;
  if (!liq) return;
  const totalNeto = (liq.detalle_empleados || []).reduce((s, d) => s + d.netoPagar, 0);

  state.modal = `
    <div data-action="close-modal-bg" style="position:fixed;top:0;right:0;bottom:0;left:0;background:rgba(15,23,42,.45);display:flex;align-items:center;justify-content:center;z-index:1000;padding:11px;">
      <div data-action="prevent-close" style="background:white;border-radius:14px;width:560px;max-width:100%;max-height:90vh;overflow:auto;box-shadow:0 20px 60px rgba(0,0,0,.2);">
        <div style="padding:10px 12px;border-bottom:1px solid ${C.border};display:flex;justify-content:space-between;align-items:center;background:#f8fafc;">
          <h3 style="margin:0;font-size:16px;color:${C.text};font-weight:700;">✅ Confirmar liquidación de nómina</h3>
          <button data-action="close-modal" style="background:transparent;border:none;font-size:16px;color:${C.muted};cursor:pointer;">✕</button>
        </div>
        <div style="padding:11px;">
          <div style="background:#f8fafc;border-radius:6px;padding:10px;margin-bottom:10px;">
            <div style="font-size:10.5px;color:${C.muted};font-weight:700;margin-bottom:6px;">RESUMEN</div>
            <div style="font-size:12px;color:${C.text};">${PERIODICIDAD_NOMINA_LABELS[liq.tipo_periodo] || liq.tipo_periodo} · ${fmtDate(liq.periodo_desde)} → ${fmtDate(liq.periodo_hasta)}</div>
            <div style="font-size:12px;color:${C.muted};margin-top:4px;">${(liq.detalle_empleados || []).length} empleado${(liq.detalle_empleados || []).length !== 1 ? "s" : ""}</div>
            <div style="font-size:16px;font-weight:800;color:#4C5FA8;margin-top:8px;">Neto total: ${fmtCOP(totalNeto)}</div>
          </div>

          <div style="background:#fef3c7;border:1px solid #fcd34d;border-radius:6px;padding:10px;margin-bottom:10px;">
            <div style="font-weight:700;color:#92400e;margin-bottom:4px;">⚠️ Nómina electrónica DIAN aún no conectada</div>
            <div style="font-size:11.5px;color:#78350f;">No hay un proveedor tecnológico autorizado conectado todavía. La opción de nómina electrónica de abajo genera un CUNE simulado localmente y queda marcada como "sin validez fiscal ante la DIAN". Úsala solo para pruebas internas hasta que se conecte una integración real (ej. Dataico u otro proveedor de nómina electrónica).</div>
          </div>

          <div style="font-size:11.5px;color:${C.muted};margin-bottom:10px;">En ambos casos se genera igual el asiento contable consolidado en el Libro Diario y se guarda la liquidación en el histórico. La única diferencia es si además se generan documentos de nómina electrónica (simulados).</div>

          <div style="display:flex;gap:10px;justify-content:flex-end;padding-top:14px;border-top:1px solid ${C.border};flex-wrap:wrap;">
            <button data-action="close-modal" style="${btnStyle(null,"secondary")}">Cancelar</button>
            <button data-action="nomina-confirmar-final" data-electronica="false" style="${btnStyle("#6b7280")}" title="Confirma la liquidación y genera el asiento contable, sin generar ningún documento DIAN.">📝 Solo registrar</button>
            <button data-action="nomina-confirmar-final" data-electronica="true" style="${btnStyle("#4C5FA8")}" title="Genera un CUNE simulado por empleado; no llama todavía a la API real de ningún proveedor de nómina electrónica.">📤 Generar nómina electrónica (CUNE simulado)</button>
          </div>
        </div>
      </div>
    </div>
  `;
  render();
}

function showNominaElectronicaModal(liquidacionId) {
  const liq = (state.data.nomina_liquidaciones || []).find(l => l.id === liquidacionId);
  if (!liq) return;
  const docs = liq.nomina_electronica || [];

  state.modal = `
    <div data-action="close-modal-bg" style="position:fixed;top:0;right:0;bottom:0;left:0;background:rgba(15,23,42,.45);display:flex;align-items:center;justify-content:center;z-index:1000;padding:11px;">
      <div data-action="prevent-close" style="background:white;border-radius:14px;width:640px;max-width:100%;max-height:90vh;overflow:auto;box-shadow:0 20px 60px rgba(0,0,0,.2);">
        <div style="padding:10px 12px;border-bottom:1px solid ${C.border};display:flex;justify-content:space-between;align-items:center;background:#f8fafc;">
          <h3 style="margin:0;font-size:16px;color:${C.text};font-weight:700;">📤 Nómina electrónica — ${escapeHTML(liq.numero || "")}</h3>
          <button data-action="close-modal" style="background:transparent;border:none;font-size:16px;color:${C.muted};cursor:pointer;">✕</button>
        </div>
        <div style="padding:11px;">
          <div style="background:#fef3c7;border:1px solid #fcd34d;border-radius:6px;padding:10px;font-size:10.5px;color:#78350f;margin-bottom:10px;">
            ⚠️ Estos documentos y sus CUNE son simulados localmente. No tienen validez fiscal ante la DIAN hasta que se conecte un proveedor tecnológico autorizado.
          </div>
          ${docs.length === 0 ? `<div style="font-size:11.5px;color:${C.muted};">Esta liquidación no generó documentos de nómina electrónica (se confirmó como "solo registrar").</div>` : docs.map(doc => `
            <div style="background:#f8fafc;border:1px solid ${C.border};border-radius:6px;padding:10px;margin-bottom:10px;">
              <div style="font-weight:700;color:${C.text};">${escapeHTML(doc.empleadoNombre)}</div>
              <div style="font-size:11.5px;color:${C.muted};margin-top:4px;">Devengado: <strong>${fmtCOP(doc.devengado)}</strong> · Deducciones: <strong>${fmtCOP(doc.deducciones)}</strong> · Neto: <strong style="color:#4C5FA8;">${fmtCOP(doc.netoPagar)}</strong></div>
              <div style="font-size:10px;color:${C.muted};margin-top:6px;word-break:break-all;">CUNE: ${doc.cune}</div>
              <div style="font-size:10px;color:${C.muted};">Generado: ${fmtDate(doc.fechaGeneracion.slice(0,10))}</div>
            </div>
          `).join("")}
          <div style="display:flex;justify-content:flex-end;padding-top:14px;border-top:1px solid ${C.border};">
            <button data-action="close-modal" style="${btnStyle(null,"secondary")}">Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  `;
  render();
}

import { registerActions } from "../ui/actions.js";

registerActions({
  "nomina-tab": (d, el, e) => {{
      state.nominaTab = d.tab;
      render();
      return;
    }},
  "nomina-calcular": (d, el, e) => {{
      const tipo_periodo = document.getElementById("nomina-tipo-periodo")?.value || "mensual";
      const periodo_desde = document.getElementById("nomina-periodo-desde")?.value;
      const periodo_hasta = document.getElementById("nomina-periodo-hasta")?.value;
      const fecha_pago = document.getElementById("nomina-fecha-pago")?.value || today();
      if (!periodo_desde || !periodo_hasta || periodo_desde > periodo_hasta) {
        alert("⚠️ Selecciona un rango de fechas válido (desde no puede ser posterior a hasta).");
        return;
      }
      const parametrosNomina = getParametrosNomina();
      const empleados = (state.data.empleados || []).filter(emp => parseNumber(emp.salario_base) > 0);
      if (empleados.length === 0) {
        alert("⚠️ No hay empleados con salario base configurado. Agrégalo en Empleados antes de liquidar.");
        return;
      }
      const periodo = { desde: periodo_desde, hasta: periodo_hasta };
      const detalle_empleados = empleados.map(emp => {
        const comisiones = calcularComisionesPeriodo(emp, periodo_desde, periodo_hasta);
        const resultado = liquidarEmpleado(emp, periodo, parametrosNomina, { comisiones });
        return { ...resultado, empleadoNombre: emp.nombre, empleadoCargo: emp.cargo };
      });
      state.nominaLiquidacionActual = {
        id: genId(), tipo_periodo, periodo_desde, periodo_hasta, fecha_pago,
        estado: "borrador", detalle_empleados
      };
      render();
      return;
    }},
  "nomina-descartar": (d, el, e) => {{
      if (!confirm("¿Descartar esta liquidación calculada? No se guardará nada.")) return;
      state.nominaLiquidacionActual = null;
      render();
      return;
    }},
  "nomina-abrir-confirmar": (d, el, e) => {{
      showConfirmarNominaModal();
      return;
    }},
  "nomina-confirmar-final": async (d, el, e) => {{
      const liq = state.nominaLiquidacionActual;
      if (!liq) return;
      const generarElectronica = d.electronica === "true";
      try {
        const numero = await siguienteNumeroDoc("NOM");
        const asiento = await generarAsientoNomina({ ...liq, numero });
        const nomina_electronica = generarElectronica
          ? liq.detalle_empleados.map(det => ({
              empleadoId: det.empleadoId,
              empleadoNombre: det.empleadoNombre,
              cune: "CUNE-" + Math.random().toString(36).slice(2, 18).toUpperCase(),
              fechaGeneracion: new Date().toISOString(),
              devengado: det.devengado.totalDevengado,
              deducciones: det.deducciones.totalDeducciones,
              netoPagar: det.netoPagar
            }))
          : [];
        const liquidacionFinal = { ...liq, numero, estado: "confirmada", asiento_id: asiento.id, nomina_electronica };
        saveData("nomina_liquidaciones", [...(state.data.nomina_liquidaciones || []), liquidacionFinal]);
        state.nominaLiquidacionActual = null;
        state.nominaTab = "historico";
        state.modal = null;
        alert(`✅ Nómina ${numero} confirmada. Asiento contable ${asiento.numero} generado en el Libro Diario.` +
          (generarElectronica ? " Se generaron documentos de nómina electrónica simulados (sin validez fiscal ante la DIAN)." : ""));
        render();
      } catch (err) {
        alert("⚠️ " + err.message);
      }
      return;
    }},
  "nomina-ver-electronica": (d, el, e) => {{
      showNominaElectronicaModal(d.id);
      return;
    }},
  "nomina-guardar-parametros": (d, el, e) => {{
      const pn = getParametrosNomina();
      const campos = [
        "anio_vigencia", "smlmv", "auxilio_transporte", "auxilio_transporte_tope_smlmv",
        "salud_empleado_pct", "pension_empleado_pct", "salud_patronal_pct", "pension_patronal_pct",
        "sena_pct", "icbf_pct", "caja_compensacion_pct",
        "cesantias_pct", "intereses_cesantias_pct", "prima_pct", "vacaciones_pct"
      ];
      campos.forEach(key => {
        const input = document.getElementById(`pn-${key}`);
        if (input) pn[key] = parseFloat(input.value) || 0;
      });
      const periodicidad = document.getElementById("pn-periodicidad_default")?.value;
      if (periodicidad) pn.periodicidad_default = periodicidad;
      pn.exonera_sena_icbf = !!document.getElementById("pn-exonera_sena_icbf")?.checked;
      pn.exonera_salud_patronal = !!document.getElementById("pn-exonera_salud_patronal")?.checked;
      pn.tabla_arl = { ...(pn.tabla_arl || {}) };
      NIVELES_RIESGO_ARL.forEach(n => {
        const input = document.getElementById(`pn-tabla_arl-${n}`);
        if (input) pn.tabla_arl[n] = parseFloat(input.value) || 0;
      });
      saveParametrosNomina(pn);
      alert("✅ Parámetros de nómina guardados.");
      render();
      return;
    }},
  "nomina-restaurar-parametros": (d, el, e) => {{
      if (!confirm("¿Restaurar los parámetros de nómina a los valores por defecto?")) return;
      saveParametrosNomina({ ...DEFAULT_PARAMETROS_NOMINA });
      render();
      return;
    }},
});
